import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, Col, Row, Select } from "antd";
import LazyLoadSelect from "./LazyLoadSelect";
import { nonEmpty } from "../../../swzutils";
import { PlusOutlined } from "@ant-design/icons";
import SenderReceiverEditModal from "../routes/sendersReceivers/edit/SenderReceiverEditModal";
export default function SenderReceiverSelect({ tenantId, disabled = false, senderReceiverId, style, allowClear = false, allowCreate = false, allowsPickups, onChange, onSenderReceiverSelected }) {
    const [modalOpen, setModalOpen] = useState(false);
    const optionsRenderer = (senderReceivers) => {
        return senderReceivers.map(senderReceiver => {
            const description = nonEmpty `${senderReceiver.companyName} - ${senderReceiver.address?.unitOrFlat} ${senderReceiver.address?.street} ${senderReceiver.address?.suburb}`;
            return _jsx(Select.Option, { value: senderReceiver.id, filter: description, children: description }, senderReceiver.id);
        });
    };
    const onAddButtonClicked = () => {
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalOpen(false);
    };
    return (_jsxs(Row, { wrap: false, children: [_jsx(Col, { flex: "auto", children: _jsx(LazyLoadSelect, { url: "/admin/v1/sender-receivers", tenantId: tenantId, disabled: disabled, allowClear: allowClear, style: style, value: senderReceiverId, placeholder: "Select a saved location", notFoundMessage: "No saved locations found", searchKey: "companyNameOrSuburbLike", queryParams: {
                        enabled: true,
                        allowsPickups
                    }, onChange: onChange, onSelected: onSenderReceiverSelected, optionsRenderer: optionsRenderer }) }), allowCreate &&
                _jsx(Col, { flex: "150px", children: _jsxs(Button, { htmlType: "button", className: "pull-right", type: "default", onClick: onAddButtonClicked, children: [_jsx(PlusOutlined, {}), " New address"] }) }), allowCreate &&
                _jsx(SenderReceiverEditModal, { open: modalOpen, onUpdated: senderReceiver => {
                        onSenderReceiverSelected && onSenderReceiverSelected(senderReceiver);
                        onChange && onChange(senderReceiver.id);
                        closeModal();
                    }, onCancel: closeModal })] }));
}
;
